export const GS_PREFIX = "gs://";

export enum HandoutBucket {
	DEFAULT = "project-handout.appspot.com",
	AVATARS = "asia-south1.avatars.project-handout.hashimukh.org",
}